<template>
    <div class="base-pwd-modify" :class="{'pwdmod-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">修改密码</div>
            <div>
                <input class="val" type="text" maxlength="16" placeholder="请输入旧密码" v-model="oldPwd" />
                <input class="val" type="text" maxlength="16" placeholder="请输入新密码（6~16位数字或字母）" v-model="newPwd" />
                <input class="val" type="text" maxlength="16" placeholder="请确认新密码（6~16位数字或字母）" v-model="confirmPwd" />
            </div>
            <div class="btn">
                <div class="item" @click="onOut">暂不修改</div>
                <div class="item" @click="submit">确认修改</div>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        data () {
            return {
                oldPwd: '',
                newPwd: '',
                confirmPwd: '',
                msg: null,
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childPwd', null)
            },
            // 修改密码
            submit () {
                // 数字或字母正则
                // let reg = /^[0-9a-zA-Z]*$/g
                let accountData = JSON.parse(sessionStorage.getItem('accountData'))
                // let h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))    //+
                if (this.newPwd.replace(/\s*/g, "") || this.confirmPwd.replace(/\s*/g, "")) {
                    if (this.newPwd.replace(/\s*/g, "").length >= 6 || this.confirmPwd.replace(/\s*/g, "").length >= 6) {
                        if (this.newPwd.replace(/\s*/g, "") == this.confirmPwd.replace(/\s*/g, "")) {
                            let options = {
                                id: accountData.uid,
                                appid: accountData.appid,
                                password: this.oldPwd,
                                newpassword: this.newPwd
                            }
                            options.sign = this.util.getSign(options, accountData.appkey)
                            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=modify_password',this.$qs.stringify(options)).then(res => {
                                if (res.data.status == 1) {
                                    if (this.config.system == 2) {
                                        let account = JSON.parse(localStorage.getItem('iosUser')).account
                                        localStorage.setItem('iosUser', JSON.stringify({
                                            account: account,
                                            password: this.newPwd
                                        }))
                                    }
                                    this.msg = '修改成功'
                                    setTimeout(() => {
                                        this.msg = null
                                        this.$emit('childPwd', null)
                                    }, 1000)
                                } else {
                                    this.msg = res.data.msg
                                    setTimeout(() => {
                                        this.msg = null
                                    }, 2000)
                                }
                            }).
                            catch(o => {
                                this.msg = '请求失败'
                                setTimeout(() => {
                                    this.msg = null
                                }, 2000)
                            })
                        } else {
                            this.msg = '两次密码输入不一致'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = '密码长度为6到16位'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-pwd-modify {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                outline: none;
            }
            .val:last-child {
                margin-bottom: 0;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .pwdmod-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin-bottom: 54px;
            }
            .val:last-child {
                margin-bottom: 0;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>